module.exports = function(bootstrap) {
	bootstrap.service("contentService", ["$http","$q","$timeout", function($http, $q, $timeout) {
		this.cache = {};
		this.get = function(id,allContent) {
			// assumption contend id follows [APPID]_[PAGE]_[SPECIFIC CONTENT]
			var fileName;
			if(allContent){
				fileName=id;
			}else{
				var splitIds=id.split("_");
				fileName=splitIds[0].concat("_").concat(splitIds[1]);
			}
			return $http.get("/etc/designs/eprweb/app/resources/content/" + fileName + ".json", { cache: true }).then(
				function (response) {
					if (allContent) {
						return response.data;
					} else {
						return response.data[id];
					}
			});
		};
		this.getAll = function(id){
			return this.get(id,true);
		};
		this.loadContent=function(id,allContent){

		};
	}]);
	bootstrap.directive("aemContent", ["contentService", "smoothFocus", function(contentService, smoothFocus) {
		return {
			priority: 1001,	// Priority higher than ng-repeat.  This allows teamsite direcdtive to be placed on the same element as ng-repeat, and using
							// the "teamsiteId as myVar" syntax, combined with ng-repeat "something in myVar", you can repeat over JSON data retrieved from teamsite
			scope: true,	// Create new scope, but not isolate.  This is usefull for the "teamsiteId as myVar" syntax
			link: function($scope, element, attrs, controller, transclude) {
				$scope.teamsite = attrs.aemContent;
				var match = /^\s*([\s\S]+?)\s+as\s+([\s\S]+?)\s*$/.exec($scope.teamsite);
				var teamsiteId = $scope.teamsite;
				var lhs, rhs;
				if (match) {
					teamsiteId = match[1];
					rhs = match[2];
				}
				$scope.options = contentService.options;
				$scope.$watch('options.devMode', function() {
					contentService.get(teamsiteId).then(function(content) {
						if (match) {
							try {
								$scope[rhs] = JSON.parse(content);
							}
							catch (e) {
								$scope[rhs] = content;
							}
						}
						else {
							element.html(content);
						}
						// Adjust focus incase teamsite content caused things on the page to be pushed around
						setTimeout(function() {
							smoothFocus.setTab();
						}, 500);
					});
				});
			}
		};
	}]);
}
